<ng-container *ngIf="loadingComments===true">
  <app-preloader [loaderText]="'Loading Comments'" class="w-100 position-fixed preloader-backdrop"></app-preloader>
</ng-container>

<div class="overflow-auto" id="commentPanel">
  <div class="row mx-0 justify-content-end py-3">
    <div class="col-auto d-flex align-items-center pr-0">
      <label for="showDetails" id="showDetailsLabel" class="font-bold mb-0 pr-2">
        View: </label>
      <select id="showDetails" [(ngModel)]="filteredStatus" [ngModelOptions]="{standalone: true}" class="custom-select"
        (change)="filterCommentList()">
        <option [ngValue]="obj.value" *ngFor="let obj of filteredList;let i =index"
          id="{{obj.name.split(' ').join('')+i}}">{{obj.name}}</option>
      </select>
    </div>

    <div class="col-auto">
      <button class="btn btn-primary" id="onexpandBtn" (click)="onExpandAllClick()" [disabled]="!hasAnyComments">
        {{(expandAll===false || collapseAll===true) ? 'Expand' : 'Collapse'}} All
      </button>
    </div>
  </div>

  <div class="comment px-2 col-8" *ngIf="loadingComments===false" id="commentListMain">
    <p *ngIf="filteredCommentedNodeList?.length < 1" role="alert"><span class="sr-only">Error</span> No comments found!</p>

    <ng-container *ngFor="let node of filteredCommentedNodeList | slice:startIndex:lastIndex;let nodeIndex=index">
      <p class="mt-2 node-title">
        <a (click)="redirectTaxonomy(node)" [mathJax]="node?.node_name" id="nodeTitle"></a>
      </p>

      <div class="card shadow mb-4" *ngFor="let data of node.threads;let rowIndex=index">
        <div class="card-header d-flex justify-content-between col-12 border-bottom-0">
          <div class="col-6 p-0">
            <div class="media mb-0">
              <div class="media-body">
                <h2 class="font-bold mb-0 h6">{{ data.created_by_name }}</h2>
                <p class="comment-time mb-0">
                  <small>{{ formateDate1(data) }}</small></p>
              </div>
            </div>
          </div>

          <div class="col-6 p-0">
            <div class="d-flex justify-content-end align-items-center">
              <div class="col-auto text-uppercase p-0" *ngIf="showHistoryBtn">
                <ng-container *ngFor="let item of commentActions">
                  <p class="mb-0 status" *ngIf="data.status === item.value">{{item.name}}</p>
                </ng-container>
              </div>

              <div class="col-auto p-0" *ngIf="!preventEdit ? checkCanChageStatus(data) : false">
                <div class="dropdown">
                  <button type="button" class="btn btn-clear custom-icon-size" id="dropdownMenu2" data-toggle="dropdown"
                    aria-haspopup="true" aria-label="more options" aria-controls="menu2">
                    <span class="material-icons-outlined font-4x mt-1" aria-hidden="true">more_horiz</span>
                  </button>

                  <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenu2">
                    <ul id="menu2" role="menu" class="list-unstyled">
                      <ng-container *ngFor="let item of commentActions ;let i = index">
                        <li role="none">
                              <button
                                  role="menuitem"
                                  tabindex="-1"
                                  class="btn btn-clear btn-sm dropdown-item"
                                  id="'chngstatusBtn-'{{i}}"
                                  [disabled]="data?.status===item?.value"
                                  (click)='changeStatus(item.value,data.thread_id,data.thread_comment_id,data.thread_source_type,node.node_id,item.name)'>
                                  {{item.name}}
                              </button>
                        </li>
                      </ng-container>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card-body py-0">
          <p class="font-bold text-truncate mb-0">Assigned to: {{ data.assigned_to }}</p>

          <p class="card-text" *ngIf="!checkCanEdit(data)">
            {{ data.comment }}
          </p>
          <p *ngIf="checkCanEdit(data)" class="card-text" [attr.contenteditable]="editComments" role="textbox"
            (blur)="editCommentTitle($event,data.thread_comment_id,data.thread_id,data.thread_source_type,rowIndex,node.threads,node.node_id)"
            aria-live="polite" aria-atomic="true">
            {{ data.comment }}
          </p>

          <p class="font-bold text-truncate mb-0" *ngIf="data.metadata_name">Metadata Name: {{ data.metadata_name }}</p>

          <div class="text-right pr-2 pb-1">
            <ng-container *ngIf="!preventEdit">
              <div
                [ngStyle]="{'opacity':(rowIndex !==commentIndex && data.comments?.length === 1 && showReply)? '1' : '0' }">
                <button type="button" data-toggle="collapse" data-target="#commentBox"
                  [ngStyle]="{'opacity':checkCanReplyToOthers(data) ? '1' : '0' }"
                  [attr.aria-expanded]="showReply ? 'false': 'true'" aria-controls="commentBox"
                  class="btn btn-cancel btn-reply text-underline p-1" id="addreplyBtn"
                  (click)="addReply(nodeIndex,rowIndex,data)">Reply</button>
              </div>


              <div
                [ngStyle]="{'opacity': (rowIndex !==commentIndex && data.comments?.length !== 1 &&  showReply)  ? '1' : '0' }">
                <button type="button" [ngStyle]="{'opacity':checkCanReplyToOthers(data) ? '1' : '0' }"
                  class="btn btn-cancel btn-reply text-underline" id="replyBtn" data-toggle="collapse"
                  data-target="#commentBox" [attr.aria-expanded]="showReply ? 'false': 'true'" aria-controls="commentBox"
                  (click)="addReply(nodeIndex,rowIndex,data)">Reply</button>
              </div>
            </ng-container>
          </div>
        </div>

        <div class="card-footer border-top-0 py-0"
          *ngIf="data.comments && data.comments?.length > 0 && !checkCommentExpanded('collapseReply'+nodeIndex+rowIndex)">
          <button type="button" class="btn btn-clear p-1" id="collapseReplyBtn" data-toggle="collapse"
            [attr.aria-expanded]="checkCommentExpanded('collapseReply'+nodeIndex+rowIndex)"
            [attr.data-target]="'#collapseReply'+nodeIndex+rowIndex" (click)="checkAllExpanded($event)">
            {{data.comments.length+' comment'+((data.comments.length > 1) ? 's' : '')}}
          </button>
        </div>

        <div class="card-footer collapse reply" id="{{'collapseReply'+nodeIndex+rowIndex}}">
          <ng-container *ngFor="let comment of data.comments; let i = index">
            <div class="col-12 py-3 px-0" [ngClass]="{'border-bottom': (i !== (data.comments?.length-1))}"
              aria-live="polite" aria-atomic="true">

              <figure class="media mb-0">
                <figcaption class="media-body">
                  <h2 class="mb-0 font-bold h6">{{ comment.created_by_name }}</h2>
                  <p class="comment-time">
                    <small>{{ formateDate(comment) }}</small>
                  </p>
                </figcaption>
              </figure>

              <p class="card-text" *ngIf="!checkCanEdit(comment)">
                {{ comment.comment }}
              </p>

              <p *ngIf="checkCanEdit(comment)" class="card-text" role="textbox"
                [attr.contenteditable]="!preventEdit ? checkCanEdit(comment) : false"
                (blur)="editCommentTitle($event,comment.thread_comment_id,data.thread_id,data.thread_source_type,i,data.comments,node.node_id)">
                {{ comment.comment }}
              </p>
            </div>
          </ng-container>
        </div>

        <div id="comment-all" class="collapse">
        </div>

        <div class="card reply border-0" id="commentBox"
          *ngIf="commentBody && nodeIndex===currentNodeIndex && rowIndex ===commentIndex && showReply">
          <div class="card-footer comment__body reply__section">
            <div class="form-group">
              <label for="{{'writeReply'+nodeIndex+rowIndex}}" id="addreplyLabel">Replying</label>
              <textarea class="form-control" placeholder="Add a reply" id="{{'writeReply'+nodeIndex+rowIndex}}" rows="2"
                [(ngModel)]="comment"></textarea>
            </div>
            <div class="form-group" *ngIf="showAssignTo && itemType===2">
              <label for="assign-to" class="sr-only" id="assignLabel">Assign to</label>
              <select class="custom-select" id="assign-to" [(ngModel)]="selectedUser" (change)="selectAssignTo()">
                <option *ngFor="let user of userList ; let i = index" [ngValue]="user"
                  [disabled]="selectedUser?.user_id===user?.user_id" id="{{ user.full_name.split(' ').join('')+i }}">
                  {{ user.full_name }}</option>
              </select>
            </div>
            <div class="float-right">
              <button type="button" class="btn btn-cancel text-underline" id="clnBtncl" data-dismiss="modal"
                (click)="cancelCommentForCard()">Cancel</button>
              <button type="button" class="btn btn-primary btn-sm" id="addBtncl" [disabled]="!comment"
                (click)="addCommentForCard(rowIndex,data,node.node_id)">Add</button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <app-pagination
      [hidden]="filteredCommentedNodeList === undefined || (filteredCommentedNodeList && filteredCommentedNodeList?.length < minItemPerPage)"
      [dataLength]="filteredCommentedNodeList ? filteredCommentedNodeList?.length : 0"
      (displayItemRangeEvent)="showDataInRange($event)"></app-pagination>
  </div>
</div>

